import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { ITask } from '@fi-shared/fi-task-shared/fi-task-shared';
import { IAccessRightFilterCollection } from '@fi-shared/models';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';

@Component({
    selector: 'fi-task-edit-task',
    templateUrl: './task-edit-task.component.html',
    styleUrls: ['./task-edit-task.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-edit-task' },
    providers: [{ provide: FiComponentsContainer, useExisting: TaskEditTaskComponent }],
    standalone: false,
})
export class TaskEditTaskComponent extends FiComponentsContainer implements OnInit {
    @Input() task: ITask;
    @Input() accessRightFilterCollection: IAccessRightFilterCollection;
    @Output() saveClick = new EventEmitter();

    constructor() {
        super();
    }

    ngOnInit() {}

    onSaveClick() {
        this.saveClick.emit();
    }

    onTaskNameChanged($event: { name: string; description: string }) {
        this.task.Name = $event.name;
        this.task.Description = $event.description;
    }

    doValidate() {
        return {
            required: false,
        };
    }
}
